import { setValidateSubscription } from "./slices/userSlice";

export const validateSubscriptionAction =
  (apiInstance, role, userId) => async (dispatch) => {
    try {
      let url = "";
      if (role === "athlete") {
        url = `/athlete/profile/${userId}`;
      }
      if (role === "university") {
        url = `/coach/profile`;
      }
      if (role !== "admin") {
        const response = await apiInstance.get(url);
        if (response.status === 200) {
          if (response.data.hasCurrentSubscription === true) {
            dispatch(setValidateSubscription(true));
          }
        }
      } else {
        dispatch(setValidateSubscription(true));
      }
    } catch (error) {
      console.error(error);
    }
  };
